import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.updateApiKey
)

export const selectIsUpdateApiKeyModalOpen = createSelector(
    baseSelector,
    (state) => state.isUpdateApiKeyModalOpen
)

export const selectIsRecreateApiKeyModalOpen = createSelector(
    baseSelector,
    (state) => state.isRecreateApiKeyModalOpen
)

export const selectOnRecreate = createSelector(
    baseSelector,
    (state) => state.onRecreate
)

export const selectOnUpdate = createSelector(
    baseSelector,
    (state) => state.onUpdate
)

export const selectCurrentApiKey = createSelector(
    baseSelector,
    (state) => state.currentApiKey
)
